import {Modal} from 'antd';
import {AxiosError} from 'axios';
import {ModalFuncProps} from 'antd/lib/modal/Modal';
import locales from '../locales';

export interface IGlobalErrorHandler {
  handle401: (error: AxiosError) => void;
  handle403: (error: AxiosError) => void;
}

interface ModalHandle {
  destroy: () => void;
  update: (newConfig: ModalFuncProps) => void;
}

interface GlobalErrorHandlerProps {
  logoutAction: () => void;
}

class GlobalErrorHandler implements IGlobalErrorHandler {

  private props: GlobalErrorHandlerProps;
  private error401Modal: ModalHandle;
  private error403Modal: ModalHandle;

  constructor(props: GlobalErrorHandlerProps) {
    this.props = props;

    this.error401Modal = Modal.warning({
      title: locales.invalid_session,
      content: locales.logged_out,
      okText: locales.ok,
    });
    this.error401Modal.update({
      visible: false,
    });

    this.error403Modal = Modal.error({
      title: locales.error,
      content: locales.invalid_role,
      okText: locales.ok,
    });
    this.error403Modal.update({
      visible: false,
    });
  }

  public handle401(error: AxiosError) {
    this.props.logoutAction();
    this.error401Modal.update({
      visible: true,
    });
  }

  public handle403(error: AxiosError) {
    this.error403Modal.update({
      visible: true,
    });
  }
}

export default GlobalErrorHandler;



// WEBPACK FOOTER //
// ./src/common/GlobalErrorHandler.tsx